import React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import FormControlLabel from '@mui/material/FormControlLabel';
import style from '../../styles.css';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import IconButton from '@mui/material/IconButton';
import darkStyle from '../../components/styles/darkStyle.css';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import List from '@mui/material/List';
import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import Navbar from '../Navbar/Navbar';
import {Elements} from '@stripe/react-stripe-js';
import localStyles from './styles.css';

function Contact({stripePromise, user, showSuccess, showError}) {
  return (
    <div className="dark-style">
      <Navbar user={user} showSuccess={showSuccess} showError={showError} />
      <Container
        sx={{
          marginTop: '40px',
          marginBottom: '40px',
          textAlign: 'center',
          justifyContent: 'center',
        }}
        maxWidth="md">
        <Typography className="title" variant="h2">
          Contact Us
        </Typography>
        <a className="contact-container" href="mailto:afries@finsiteful.com">
          <div
            className="pill-box white"
            style={{
              width: '100%',
              maxWidth: 750,
              padding: 31,
              textAlign: 'center',
            }}>
            <div>
              <strong>Axel Fries</strong>
            </div>
            <div className="email">afries@finsiteful.com</div>
          </div>
        </a>
        <a className="contact-container" href="mailto:jclary@finsiteful.com">
          <div
            className="pill-box white"
            style={{
              width: '100%',
              maxWidth: 750,
              padding: 31,
              textAlign: 'center',
            }}>
            <div>
              <strong>Jack Clary</strong>
            </div>
            <div className="email">jclary@finsiteful.com</div>
          </div>
        </a>
      </Container>
    </div>
  );
}

export default Contact;
